import axios from 'axios';

export const TOKEN_KEY = 'auth_token'; // usa esta MISMA clave en todo lado

const fromEnv =
  (import.meta as any)?.env?.VITE_API_BASE_URL ||
  (import.meta as any)?.env?.VITE_BACKEND_URL ||
  '';

const BASE = (fromEnv ? String(fromEnv) : '/go-planilla').replace(/\/+$/, '');

const api = axios.create({
  baseURL: BASE,           // ==> '/go-planilla' en prod
  headers: { 'Content-Type': 'application/json' },
  withCredentials: false,
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      config.headers = config.headers || {};
      (config.headers as any).Authorization = `Bearer ${token}`;
    }
  } catch {}
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const data = err?.response?.data;
    const message = data?.message || err.message || 'Error de red';
    return Promise.reject(Object.assign(new Error(message), { status, details: data }));
  }
);

export default api;
